var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"outlined":"","small":"","color":_vm.color},on:{"click":_vm.accion}},[_vm._v(" "+_vm._s(_vm.texto)+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v(_vm._s(_vm.icono === "import" ? "mdi-upload" : "mdi-file-excel"))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }